import { useParams } from "react-router";
import { ApiUsers } from "../../../core/apis/users";
import { ProfileCard } from "../../../features/users/profile/profileCard.component";
import { ContactInfoCard } from "../../../features/users/profile/contactInfoCard.component";

export const PageSingleUser = () => {
  const { userId } = useParams<{ userId: string }>();
  const { data, isValidating } = ApiUsers.ById.Hook(userId);

  return (
    <>
      <ProfileCard data={data} isValidating={isValidating} />
      <ContactInfoCard data={data} isValidating={isValidating} />
    </>
  );
};
